import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from '../components/enums'

export const editComment = async (data: object) => {
  return axios.put(endpoints.updateComment, data)
}

export const useEditComment = () => {
  // invalidate fetched profile data
  const client = useQueryClient()
  return useMutation(editComment, {
    onSuccess: () => {
      client.invalidateQueries([ApiKey.comment, ApiKey.message])
    },
  })
}
